import Vue from 'vue';
import { ActionTree, MutationTree } from 'vuex';
import { RootState } from '@/store/types';
import { ServerResult } from '@/core/http/server_result';
import { fetchEnumsFromSchema } from '@/core/tools/forms/fetch_enums_from_schema';
import { groupBy } from 'lodash'
import moment from 'moment';
import { Filesystem } from '@capacitor/core';

interface WarehousesListState {
    loaded: boolean;
    loading: boolean;
    fatalError: boolean;

    lastMeta: {
        page: number;
        pageSize: number;
        totalCount: number;
        totalPages: number;
    };

    documents: any[];
    days: any[];
    schema: any;

    meta: any;
}

const state: WarehousesListState = {
    loading: false,
    loaded: false,
    fatalError: false,

    lastMeta: {
        page: 0,
        pageSize: 0,
        totalCount: 0,
        totalPages: 0
    },

    documents: [],
    days: [],
    schema: null,

    meta: {},
};

export const ITEMS_LIST = 'GET_WAREHOUSE_REMAINS_LIST';

export const actions: ActionTree<WarehousesListState, RootState> = {
    loadData({ commit, getters, dispatch }, query) {
        const vm = (this as any)._vm;

        return new Promise((resolve, reject) => {
            commit('CLEAR_DATA');
            commit('START_LOADING');

            const columns: any = {
                "product_name": "p.name",
                "product_container_name": "pc.name",
                "product_container_weight": "pc.weight",
                "warehouse_date": "mv.warehouse_date",
                "quantity": "mv.quantity",
                "remains": "mv.remains",
                "now_quantity": "mv.now_quantity",
                "trans_quantity": "mv.trans_quantity",
            };

            const filter: any[] = [];


            filter.push({
                "$or": [
                    {"$null": ["mv.target_date"]},
                    (query.targetDate
                        ? { "$eq": ["mv.target_date", {"$": query.targetDate}] }
                        : { "$eq": ["mv.target_date", {"$": moment().add(1, 'day').format('YYYY-MM-DD')}] })
                ]
            })
            if (query.warehouse_id) {
                filter.push({ "$eq": ["mv.warehouse_id", {"$": query.warehouse_id}] })
            }

            vm.$db([
                vm.$q(ITEMS_LIST)
                    .raw('warehouse')
                    .action({
                        warehouse_id: query.warehouse_id,
                        date: query.targetDate ? query.targetDate : moment().add(1, 'day').format('YYYY-MM-DD'),
                    }),
            ]).then(((result: ServerResult) => {
                console.log(result)
                commit('SET_WAREHOUSE_DATA', result.getOperation(ITEMS_LIST).getContent());
                commit('LOADED_SUCCESS');

                resolve();
            }));

            // vm.$db([
            //     vm.$q(ITEMS_LIST)
            //     .raw('documents.list')
            //     .action({
            //         "columns": columns,
            //         "from": "s:view_warehouse_remains_list",
            //         "from_as": "mv",
            //         "joins": [
            //           {
            //             "join": "s:products",
            //             "type": "left",
            //             "as":   "p",
            //             "on": {
            //               "$eq": ["mv.product_id", "p.id"]
            //             }
            //           },
            //           {
            //             "join": "s:product_containers",
            //             "type": "left",
            //             "as":   "pc",
            //             "on": {
            //               "$eq": ["mv.product_container_id", "pc.id"]
            //             }
            //           }
            //         ],
            //         page_size: 10,
            //         ...({page: parseInt(query.page) || 1}),
            //         ...({
            //             order: [
            //                 query.sortDirection == 'asc' ? { $asc: [columns[query.sortField || 'quantity' ]] } : { $desc: [columns[query.sortField || 'quantity']] }
            //             ]
            //         }),
            //         ...(
            //             filter.length > 1 ?
            //             {
            //                 "where": {
            //                     "$and": filter
            //                 }
            //             } : {
            //                 "where": filter[0]
            //             }
            //         )

            //     })
            // ]).then(((result: ServerResult) => {
            //     commit('SET_ITEMS_LIST', result.getOperation(ITEMS_LIST).getContent());
            //     commit('LOADED_SUCCESS');

            //     resolve(null);
            // }));
        })
    },

};

export const mutations: MutationTree<WarehousesListState> = {
    START_LOADING: (state) => {
        state.loaded = false;
        state.loading = true;
        state.fatalError = false;
    },
    LOADED_SUCCESS: (state) => {
        state.loaded = true;
        state.loading = false;
        state.fatalError = false;
    },
    LOADED_ERROR: (state) => {
        state.loaded = true;
        state.loading = false;
        state.fatalError = true;
    },
    CLEAR_DATA(state, data) {
        state.days = []
        state.documents =[]
    },

    SET_WAREHOUSE_DATA(state, data) {
        state.days = data.days.map((day: any) => moment(day).format('DD.MM.YYYY'))
        state.days.splice(state.days.length - 1, 1)
        state.documents = data.data.map((row: any) => {
            if (row.product_container_id == 420) {
                console.log(row)
            }
            row.remains = parseInt(row.quantity)
            row.valid = row.quantity != 0
            row.columns = row.expected.map((item: any, idx: number) => {
                row.remains -= item
                const product_container_weight = parseFloat(row.product_container_weight)
                const col = {
                    'expected': item * product_container_weight,
                    'remains': (row.remains - row.movement[idx] + 0) * product_container_weight,
                    'movement': (row.movement[idx] + 0) * product_container_weight,
                    'availability': row.availability[idx] * product_container_weight,
                    'remains_total': (row.remains + row.availability[idx] - row.movement[idx]) * product_container_weight,
                }
                row.valid = row.availability[idx] > 0 || row.valid;
                row.remains += row.availability[idx]
                row.remains -= row.movement[idx]
                return col
            })
            row.columns.splice(row.columns.length - 1, 1)
            return row
        }).filter((item: any) => {
            return item.columns[item.columns.length - 1].remains_total != 0 || item.quantity != 0 || item.valid;
        })

        state.lastMeta = {
            page: data.meta.page,
            pageSize: data.meta.page_size,
            totalCount: data.meta.total_count,
            totalPages: data.meta.total_pages
        };
    },
};

const getters = {
    total(state: WarehousesListState) {
        return {
            quantity: state.documents.reduce((prev: any, field: any) => {
                return prev + parseInt(field.quantity)
            }, 0),
            total_quantity: state.documents.reduce((prev: any, field: any) => {
                return prev + (parseInt(field.quantity) * parseFloat(field.product_container_weight))
            }, 0),
            columns:  state.documents.reduce((prev: any, field: any) => {
                field.columns.map((item: any, idx: number) => {
                    console.log('=>', item, idx)
                    if (!prev[idx]) {
                        prev[idx] = {
                            'expected': 0,
                            'remains': 0,
                            'availability': 0,
                            'movement': 0,
                            'remains_total': 0,
                        }
                    }
                    prev[idx].expected += parseFloat(item.expected)
                    prev[idx].remains += parseFloat(item.remains)
                    prev[idx].availability += parseFloat(item.availability)
                    prev[idx].movement += parseFloat(item.movement)
                    prev[idx].remains_total += parseFloat(item.remains_total)
                })
                return prev
            }, [])
        }
    },
    exportData(state: WarehousesListState) {
        const csvContent: any[] = [];
        const header = ['Продукт', 'Тара', 'Кол-во, кг', 'Кол-во ведер', ]
        state.days.map((day) => {
            header.push(`Заявки на ${day}`)
            header.push(`Остатки после заявок на  ${day}`)
            header.push(`В пути на  ${day}`)
            header.push(`Остаток на  ${day}`)
        })
        header.push('Остаток на конец периода')
        state.documents.map((item: any) => {
            const row: any[] = [];
            row.push(item.product_name)
            row.push(item.product_container_name)
            row.push(item.quantity * item.product_container_weight)
            row.push(item.quantity)
            item.columns.map((c: any) => {
                row.push(c.expected)
                row.push(c.remains)
                row.push(c.availability)
                row.push(c.remains_total)
            })
            row.push(item.columns[item.columns.length - 1].remains_total)
            csvContent.push(row)
        })
        return [
            header,
            ...csvContent
        ]
      }
};

export const STORE_KEY = '$_warehouses_list';

export const store = {
    namespaced: true,
    state,
    actions,
    getters,
    mutations,
};
